// Domicilios de los choferes (GET /v2/driver-home), para el mapa en vivo y
// como inicio o fin de un recorrido. Piden user_access o db_access: sin
// permiso (o si falla) es `false` y quien lo usa no los ofrece; `null`
// mientras no se sabe. Las coordenadas pueden llegar como texto (columnas
// numeric de Postgres): acá se pasan a número una sola vez.
import { useEffect, useState } from "react";
import type { MapHome } from "../lib/mapLayers";
import { requestJson } from "../lib/requestJson";

export function useDriverHomes(token: string | null | undefined): MapHome[] | null | false {
  const [homes, setHomes] = useState<MapHome[] | null | false>(null);
  useEffect(() => {
    let vivo = true;
    requestJson("/v2/driver-home", { token })
      .then((j) => { if (vivo) setHomes((j.homes ?? []).map((h: any) => ({ ...h, latitude: Number(h.latitude), longitude: Number(h.longitude) }))); })
      .catch(() => { if (vivo) setHomes(false); });
    return () => { vivo = false; };
  }, [token]);
  return homes;
}
